import React from "react";
import { useWeb3 } from "../../context/Web3Context";
import { shortAddress } from "../../utils/format";

// Compares the connected wallet against this contract's owner/admin.
export default function RoleBanner({ owner, admin }) {
  const { account } = useWeb3();
  const eq = (a, b) => a && b && a.toLowerCase() === b.toLowerCase();
  const isOwner = eq(account, owner);
  const isAdmin = eq(account, admin);
  const role = isOwner ? "Owner" : isAdmin ? "Admin" : "No admin rights";
  const ok = isOwner || isAdmin;

  return (
    <div className={`role-banner ${ok ? "ok" : "warn"}`}>
      <span className="role-dot" />
      <span>You are: <strong>{role}</strong></span>
      <span className="muted role-addr">{shortAddress(account)}</span>
    </div>
  );
}
